import { defaultPulseCheckApi } from '~src/services/ApiController';
import {
  AdminFeedbackCycle,
  AdminFeedbackCycleResponse,
  AdminFeedbackEntriesResponse,
  GetAdminFeedbackEntryPayload,
  PostAdminFeedbackCyclePayload,
  PutAdminFeedbackCyclePayload,
} from './types';

export const createAdminFeedbackCycle = async (
  payload: PostAdminFeedbackCyclePayload,
): Promise<AdminFeedbackCycle> => {
  const { data } = await defaultPulseCheckApi.postAdminFeedbackCycle(payload);
  return data;
};

export const getAdminFeedbackCycles = async (): Promise<AdminFeedbackCycleResponse> => {
  const { data } = await defaultPulseCheckApi.getAdminFeedbackCycles();
  return data;
};

export const putAdminFeedbackCycle = async (
  payload: PutAdminFeedbackCyclePayload,
): Promise<AdminFeedbackCycle> => {
  const { data } = await defaultPulseCheckApi.putAdminFeedbackCycle(payload);
  return data;
};

export const deleteAdminFeedbackCycle = async (feedbackCycleId: string): Promise<void> => {
  const { data } = await defaultPulseCheckApi.deleteAdminFeedbackCycles(feedbackCycleId);
  return data;
};

export const postReminderUsers = async (feedbackCycleId: string): Promise<void> => {
  const { data } = await defaultPulseCheckApi.postRemindUsers(feedbackCycleId);
  return data;
};

export const getAdminFeedbackCycle = async (id: string): Promise<AdminFeedbackCycle> => {
  const { data } = await defaultPulseCheckApi.getAdminFeedbackCycle(id);
  return data;
};

export const getAdminFeedbackEntries = async (
  payload: GetAdminFeedbackEntryPayload,
): Promise<AdminFeedbackEntriesResponse> => {
  const { data } = await defaultPulseCheckApi.getAdminFeedbackEntries(payload);
  return data;
};
